import React from 'react';
import { FormattedMessage } from '@atlassian/jira-intl';
import { GenericEmptyState } from '../../../../../common/ui/generic-empty-state/index.tsx';
import messages from './messages.tsx';

export const ConfigEmptyState = () => (
	<GenericEmptyState
		header={<FormattedMessage {...messages.header} />}
		description={<FormattedMessage {...messages.description} />}
	/>
);
